import { Link, useParams } from "react-router-dom"
import PatientOrChart from "../../../../patient/page/PatientOrChart"
export default function ListLink({classes, item}) {
    const params = useParams()

    return <Link to={`../${item.patient.person_number}`} className={`${classes.list_item_detail} ${item.patient.person_number == params.patientId ? classes.list_item_detail_active : ''}`}>
        <div className="flex-container">
            <PatientOrChart item={item}/>
            <div className={classes.list_item_name}>{item.patient.name}</div>
        </div>
        <div className={classes.flex_wrapper}>
            <div className={classes.list_item_case}>NG{item.patient.person_number}</div>                                    
        </div>
    </Link>
}